import React, { useState } from 'react';
import { checkEnvironment } from '@saviynt/common';
import { Button, Icon, Typography } from '@saviynt/design-system';

import { type Insight } from '../../../../services/types';
import { isEmpty, useInvertedLocalize } from '../../../../utils';

import invertedMessages from './messages';

import './Insights.css';

interface RiskInsightProps {
  insight: Insight;
}

function RiskInsight({ insight }: RiskInsightProps) {
  const ECM_BASE_URL = checkEnvironment().ECM_URL;

  const l = useInvertedLocalize(invertedMessages);

  return (
    <div className='Ext-Insights-list'>
      <Icon
        kind='Entitlement'
        color='--color-data-purple-medium'
        size='large'
      />
      <div className='Ext-Insights-list-text'>
        <Typography kind='body2-bold' color='--color-navy-900'>
          {`${insight.count}  `}
        </Typography>
        <Typography kind='body2' lineLimit={1}>
          {`${insight.analyticsDescription}`}
        </Typography>
      </div>
      <div className='Ext-Insights-list-btn'>
        <Button
          type='button'
          kind='subtle'
          onClick={() => {
            const reviewURL = ECM_BASE_URL
              ? `${ECM_BASE_URL}/analyticsHistoryES/analyticsDetails?id=${insight.analyticsHistoryKey}&displayIndex=0&configKey=${insight.analyticsConfigKey}&endpointsToShow=`
              : '';

            if (!isEmpty(reviewURL)) {
              window.open(reviewURL, '_blank');
            }
          }}>
          {l('Review')}
        </Button>
      </div>
    </div>
  );
}

interface InsightsProps {
  data: Insight[];
}

export default function Insights({ data }: InsightsProps) {
  const [viewMore, setViewMore] = useState(false);

  const l = useInvertedLocalize(invertedMessages);

  return (
    <div className='Ext-Insights'>
      <Typography
        kind='h2'
        color='--color-navy-900'
        className='Ext-Insights-heading'>
        {l('Risk Insights')}
      </Typography>
      {data.slice(0, 3).map((insight) => (
        <RiskInsight insight={insight} />
      ))}
      {data.length > 3 &&
        (!viewMore ? (
          <Button
            type='button'
            kind='ghost'
            size='small'
            onClick={() => setViewMore(true)}>
            {l('View More Insights')}
          </Button>
        ) : (
          <>
            {data.slice(3).map((insight) => (
              <RiskInsight insight={insight} />
            ))}
            <Button
              type='button'
              kind='ghost'
              size='small'
              className='Ext-Insights-viewLess'
              onClick={() => setViewMore(false)}>
              {l('View less')}
            </Button>
          </>
        ))}
      {data.length < 1 && (
        <Typography kind='body2' lineLimit={1}>
          {l('No Risk Insights Available')}
        </Typography>
      )}
    </div>
  );
}
